import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { EditIcon, DeleteIcon } from '../../config/svg/CommonSvg';
import NoDataFound from '../Common/NoDataFound';
import { UpdateRow, TYPE_PILL_SLUG } from './mockData';

interface UpdatesTableProps {
	rows: UpdateRow[];
	loading?: boolean;
	onEdit: (row: UpdateRow) => void;
	onDelete: (row: UpdateRow) => void;
}

export const UpdatesTable: React.FC<UpdatesTableProps> = ({ rows, loading, onEdit, onDelete }) => {
	const { t } = useTranslation();

	return (
		<TableContainer className='whats-new-roadmap-table'>
			<Table stickyHeader aria-label={t('updatesLabel')}>
				<TableHead>
					<TableRow>
						<TableCell>{t('updateColumn')}</TableCell>
						<TableCell>{t('typeColumn')}</TableCell>
						<TableCell>{t('impactsColumn')}</TableCell>
						<TableCell>{t('versionColumn')}</TableCell>
						<TableCell>{t('releasedColumn')}</TableCell>
						<TableCell>{t('screensColumn')}</TableCell>
						<TableCell align='right' />
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.length === 0 ? (
						<TableRow>
							<TableCell colSpan={7}>
								<NoDataFound loader={!!loading} />
							</TableCell>
						</TableRow>
					) : (
						rows.map((row) => (
							<TableRow key={row.id}>
								<TableCell>
									<Typography variant='body1' className='row-title'>
										{row.title}
									</Typography>
								</TableCell>
								<TableCell>
									<span
										className={`type-pill ${
											TYPE_PILL_SLUG[row.typeName] ? `type-pill-${TYPE_PILL_SLUG[row.typeName]}` : ''
										}`}
									>
										{row.typeName}
									</span>
								</TableCell>
								<TableCell>
									<span className='impact-tag'>{row.impacts}</span>
								</TableCell>
								<TableCell>{row.version}</TableCell>
								<TableCell>{row.released}</TableCell>
								<TableCell>
									{row.screensCount > 0 ? `${row.screensCount} image${row.screensCount > 1 ? 's' : ''}` : '—'}
								</TableCell>
								<TableCell align='right'>
									<Box className='row-actions'>
										<span className='row-action-btn' id={`edit-update-${row.id}`} onClick={() => onEdit(row)}>
											<EditIcon />
										</span>
										<span className='row-action-btn' id={`delete-update-${row.id}`} onClick={() => onDelete(row)}>
											<DeleteIcon />
										</span>
									</Box>
								</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
